<script setup lang="ts">
import type {JobLight} from "~/types/job";

const config = useRuntimeConfig()
const wadPlatformBaseUrl = config.public.wadPlatformBaseUrl
const screenWidth = ref(0)

interface Skill {
  id: number | string
}

interface Job {
  matching_skills?: boolean
  [key: string]: any
}

const props = defineProps<{
  jobs: Job[]
  skills?: Skill[]
}>()

const updateWidth = () => {
  screenWidth.value = window.innerWidth
}

onMounted(() => {
  screenWidth.value = window.innerWidth
  window.addEventListener('resize', updateWidth)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateWidth)
})

const visibleJobs = computed(() => {
  switch (true) {
    case screenWidth.value < 476:
      return props.jobs.slice(0, 3);
    case screenWidth.value < 724:
      return props.jobs.slice(0, 4);
    case screenWidth.value < 1100:
      return props.jobs.slice(0, 3);
    case screenWidth.value < 1400:
      return props.jobs.slice(0, 4);
    default:
      return props.jobs;
  }
})

function goToFilteredJobs() {
  const skillIds = props.skills?.map((x) => x.id).join(',') || ''
  window.open(`${wadPlatformBaseUrl}/en/jobs?skills=${skillIds}`, '_blank')
}
</script>

<template>
  <section class="wad4-jobs-list">
    <div class="wad4-jobs-list__header">
      <div class="wad4-jobs-list__title-wrapper" @click.stop="goToFilteredJobs">
        <div class="wad4-jobs-list__title">Related jobs</div>
      </div>
      <div class="wad4-jobs-list__subtitle">Jobs that call for the skills explored in this talk.</div>
    </div>
    <section class="wad4-jobs-list__jobs">
      <JobCard class="wad4-jobs-list__jobs-card" v-for="job in visibleJobs" :job="job" :key="`${job.job_type}`" :small="true"/>
    </section>
  </section>
</template>

<style lang="scss">
.wad4-jobs-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;

  @include mqBreakPoint(0, $wad4-breakpoint-tablet-max) {
    margin-left: calc(0px - $wad4-container-padding);
    margin-right: calc(0px - $wad4-container-padding);
    padding: $wad4-container-padding;
    width: calc(100% + (2 * $wad4-container-padding));
  }

  &__jobs {
    display: flex;
    align-items: stretch;
    align-content: flex-start;
    gap: 12px;
    align-self: stretch;
    flex-wrap: wrap;

    &-card {
      min-width: 220px;
      flex: 1
    }
  }

  &__header {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 4px;
  }

  &__title {
    font-size: 24px;
    line-height: 27px;
    color: $wad4-c-text-text-primary;
    font-weight: $wad4-font-weight-semi-bold;
    margin: 0;
    font-family: $wad4-default-font-unbounded;

    &-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 8px;
      align-self: stretch;
    }

  }

  &__subtitle {
    @include text-size-mixin('md');
    margin: 0;
    color: $wad4-c-text-text-secondary;
    text-wrap: balance;
  }
}
</style>
